module.exports = __webpack_public_path__ + "img/welding-12.34f50347.jpg";